const FRONT_PAGES = {
  index: {
    name: 'Meet Nitex',
    slug: '/',
  },
  getStarted: {
    name: 'Get started',
    slug: '/get-started',
  },
}

export const useGlobalState = () => {
  const footerData = useState<Ref<FooterProps | null> | null>('footer-data', () => null)
  const settingsData = useState<Ref<Settings | null> | null>('settings-data', () => null)

  const isTransitioning = useState<boolean>(() => false)
  const loadedTransition = useState<string>(() => 'default')

  const frontPages = useState<typeof FRONT_PAGES>(() => FRONT_PAGES)

  return {
    footerData,
    settingsData,

    isTransitioning,
    loadedTransition,

    frontPages,
  }
}
